import React from 'react';
import { ThemeToggle, HamburgerButton } from '../ui';
import { NotificationsBell } from './NotificationsBell';

/**
 * Header component for rooms view
 */
export const RoomsHeader = ({
  isDarkTheme,
  onToggleTheme,
  onOpenSidebar,
  userName,
  notifications,
  unreadCount,
  onOpenNotifications,
  onNotificationClick,
  onClearNotifications,
  onTrackAlert,
}) => {
  return (
    <header className="header">
      <div className="logo">
        <HamburgerButton onClick={onOpenSidebar} />
        <div className="logo-icon">🌊</div>
        <div>
          <div className="logo-text">Aqua Monitor</div>
          <div className="logo-subtitle">Sistema de Monitoreo</div>
        </div>
      </div>
      <div className="header-right">
        {userName && (
          <div className="welcome-message">
            <span className="welcome-text">Bienvenido,</span>
            <span className="welcome-name">{userName}</span>
          </div>
        )}
        <NotificationsBell
          notifications={notifications}
          unreadCount={unreadCount}
          onOpen={onOpenNotifications}
          onNotificationClick={onNotificationClick}
          onClear={onClearNotifications}
          onTrackAlert={onTrackAlert}
        />
        <ThemeToggle isDarkTheme={isDarkTheme} onToggle={onToggleTheme} />
      </div>
    </header>
  );
};

/**
 * Header component for dashboard view
 */
export const DashboardHeader = ({
  selectedRoom,
  hasReceivedData,
  isDarkTheme,
  onToggleTheme,
  onOpenSidebar,
  onBackToRooms,
  userName,
  notifications,
  unreadCount,
  onOpenNotifications,
  onNotificationClick,
  onClearNotifications,
  onTrackAlert,
}) => {
  return (
    <header className="header">
      <div className="logo">
        <HamburgerButton onClick={onOpenSidebar} />
        <button className="back-arrow" onClick={onBackToRooms} title="Volver a Salas">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <div className="logo-icon">🌊</div>
        <div>
          <div className="logo-text">{selectedRoom}</div>
          <div className="logo-subtitle">Dashboard en tiempo real</div>
        </div>
      </div>
      <div className="header-right">
        {userName && (
          <div className="welcome-message">
            <span className="welcome-text">Bienvenido,</span>
            <span className="welcome-name">{userName}</span>
          </div>
        )}
        <NotificationsBell
          notifications={notifications}
          unreadCount={unreadCount}
          onOpen={onOpenNotifications}
          onNotificationClick={onNotificationClick}
          onClear={onClearNotifications}
          onTrackAlert={onTrackAlert}
        />
        <div className="connection-status">
          <div className={`status-dot ${hasReceivedData ? 'connected' : 'disconnected'}`}></div>
          <span>{hasReceivedData ? 'Conectado' : 'Desconectado'}</span>
        </div>
        <ThemeToggle isDarkTheme={isDarkTheme} onToggle={onToggleTheme} />
      </div>
    </header>
  );
};
